import { makeRequest, HttpRequestOptions } from '../modules/promise-wrapper-ajax';
import { nodeListToArray } from '../helpers/nodeListToArray';

export class VimeoThumbnailFetch {
    vimeoVideoElements: Array<HTMLImageElement>;
    //Uses Vimeo oEmbedAPI to get thumbnail information
    vimeoOEmbedAPI: string = 'https://vimeo.com/api/oembed.json?url=';
    vimeoUrlAPI: string = 'https://player.vimeo.com/video/';

    constructor() {
        this.vimeoVideoElements = this.getVimeoThumbnailElements();
        let self = this;
        if (this.vimeoVideoElements !== null) {
            this.getVimeoMetaDataPromisesArray()
                .then(function (values) {
                    values.forEach(function(value) {
                        let imgEl = self.vimeoVideoElements.filter(el => parseInt(el.dataset.vimeoVideo) === value.video_id)[0] as HTMLImageElement;
                        imgEl.src = value.thumbnail_url;
                    });
                })
                .catch(err => {
                    console.log("Promise.all call failed: ", err);
                });
        }
    }

    getVimeoThumbnailElements() {
        return nodeListToArray(document.querySelectorAll("[data-vimeo-video]"));
    }

    getVimeoMetaDataPromisesArray() {
        let metadataFetchPromiseArray = new Array();

        this.vimeoVideoElements.forEach(imgEl => {
            metadataFetchPromiseArray.push(
                makeRequest(
                    this.vimeoOEmbedAPI + this.vimeoUrlAPI + imgEl.dataset.vimeoVideo,
                    {
                        requestMethod: 'GET',
                        responseType: 'json'
                    }
                )
            );
        });

        return Promise.all(metadataFetchPromiseArray);
    }
}